import i18n from '../utils/i18nService'

const generateDefaultMandatoryError = (entityName: string): string =>
	`${entityName} ${i18n.t('core:labels.cannotBeSaved')}. ${i18n.t(
		'core:constants.DEFAULT_MANDATORY_ERROR'
	)}:`

export const getSuccessMessage = () => i18n.t('core:labels.successMessage')

export const getRegistrationDocumentSaveMessage = () =>
	i18n.t('pages:registrationDocument.document.saveMessage')

export const getContactSuccessMessage = () =>
	i18n.t('pages:serviceLocation.table.contact.add.successMessage')

export const getServiceSuccessMessage = () =>
	i18n.t('pages:serviceLocation.service.add.successMessage')

export const getSupplierContactSuccessMessage = () =>
	i18n.t('pages:serviceLocation.supplierContact.add.successMessage')

export const getContactDeleteSuccessMessage = () =>
	i18n.t('pages:serviceLocation.contact.delete.successMessage')

export const getServiceDeleteSuccessMessage = () =>
	i18n.t('pages:serviceLocation.service.delete.successMessage')

export const getSupplierContactDeleteSuccessMessage = () =>
	i18n.t('pages:serviceLocation.supplierContact.delete.successMessage')

export const getHistoricalInvoiceSuccessMessage = (isMultiple?: boolean) =>
	isMultiple
		? i18n.t('pages:serviceLocation.historicalInvoice.add.multipleSuccessMessage')
		: i18n.t('pages:serviceLocation.historicalInvoice.add.successMessage')

export const getHistoricalInvoiceDeleteSuccessMessage = () =>
	i18n.t('pages:serviceLocation.historicalInvoice.delete.successMessage')

export const getRegistrationDocumentUploadDocumentErrorMessage = () =>
	generateDefaultMandatoryError(i18n.t('pages:registrationDocument.document.title'))

export const getContactErrorMessage = () =>
	generateDefaultMandatoryError(i18n.t('pages:serviceLocation.table.contact.add.title'))

export const getServiceErrorMessage = () =>
	generateDefaultMandatoryError(i18n.t('pages:serviceLocation.service.title'))

export const getSupplierContactErrorMessage = () =>
	generateDefaultMandatoryError(i18n.t('pages:serviceLocation.supplierContact.title'))

export const getContactExistErrorMessage = () =>
	i18n.t('pages:serviceLocation.contact.add.emailExistMessage')

export const getServiceLocationSaveMessage = () =>
	i18n.t('pages:registrationDocument.serviceLocation.saveMessage')

export const getServiceLocationDeleteMessage = () =>
	i18n.t('pages:registrationDocument.serviceLocation.deleteMessage')

export const getServiceLocationErrorMessage = () =>
	generateDefaultMandatoryError(i18n.t('pages:registrationDocument.serviceLocation.title'))
